import { useEffect, useState } from "react";

/**
 * Counts down from `seconds` to 0, starting on mount. `restart` resets the
 * countdown to `seconds`.
 */
export function useCountdown(seconds: number) {
  const [endsAt, setEndsAt] = useState(
    () => performance.now() + seconds * 1000,
  );
  const [remaining, setRemaining] = useState(seconds);

  useEffect(() => {
    let frame = 0;
    const tick = () => {
      const next = Math.max(0, Math.ceil((endsAt - performance.now()) / 1000));
      setRemaining(next);
      if (next > 0) {
        frame = requestAnimationFrame(tick);
      }
    };
    tick();
    return () => {
      cancelAnimationFrame(frame);
    };
  }, [endsAt]);

  return {
    remaining,
    restart: () => {
      setEndsAt(performance.now() + seconds * 1000);
    },
  };
}
